module.exports = __webpack_public_path__ + "static/outro-71087fc137f09c82cf038ce2b5def01d.m4a";